import angular from 'angular';
import RwActionsDropdownComponent from './rw-actions-dropdown-component';

export default angular
  .module('rw-actions-dropdown', [])
  .component('rwActionsDropdown', new RwActionsDropdownComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-actions-dropdown/rw-actions-dropdown-module.js